/**
 * @generated SignedSource<<4b1e4cfe0bb87475466b13b985f33ac6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ChatThreadActions_User$data = {
  readonly contacts: {
    readonly totalCount: number | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "ChatThreadActions_User";
};
export type ChatThreadActions_User$key = {
  readonly " $data"?: ChatThreadActions_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"ChatThreadActions_User">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ChatThreadActions_User",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        }
      ],
      "concreteType": "UserConnection",
      "kind": "LinkedField",
      "name": "contacts",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        }
      ],
      "storageKey": "contacts(first:1)"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "f7af82738f88ee02affc0246841c0d06";

export default node;
